<div class="container-fluid">
  <div class="row mb-4 align-items-center">
    <div class="row mb-4">
      <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
        Products List
        <div class="border-green-bottom"></div>
      </div>
      <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end">
        <div class="search-area">
          <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
          <input type="text" class="search-input" placeholder="Search Product" [(ngModel)]="searchQuery" (ngModelChange)="applyFilter($event)" />
        </div>
      </div>
    </div>
    <div class="col-12 mt-3 mt-md-0 d-flex justify-content-end align-items-center gap-3">
      <button class="add-btn btn btn-primary px-4 py-2" (click)="onCreateProduct()">Add Product</button>
    </div>
  </div>

  <div class="row g-4">
    @for(product of filteredProductList; track $index) {
    <div class="col-12 col-md-6 col-lg-4 col-xl-3">
      <div class="product-card h-100 rounded-4 shadow-sm">
        <div class="card-content position-relative d-flex flex-column h-100">
          <!-- Image Section -->
          <div class="product-image-container d-flex align-items-center justify-content-center">
            <button class="btn-wishlist position-absolute top-0 end-0 m-3 rounded-circle d-flex align-items-center justify-content-center border-0" (click)="onEditProduct(product.ProductID)">
              <i class="bi bi-pencil"></i>
            </button>
            <img [src]="product.Documents?.[product.currentImageIndex]?.URL" [alt]="product.ProductName" class="product-image img-fluid object-fit-contain" />
          </div>

          <!-- Content Section -->
          <div class="p-4 d-flex flex-column flex-grow-1">
            <div class="mb-2">
              <small class="font-green fw-bold text-uppercase letter-spacing-1">{{ product.ProductCompany?.CompanyName }}</small>
              <h5 class="fw-bold font-white mb-2 mt-1">{{ product.ProductName }}</h5>
              <p class="font-gray small mb-3 text-truncate-2" style="line-height: 1.6">{{ product.Description }}</p>
            </div>

            <!-- Sizes Section -->
            <div class="mb-auto">
              <div class="d-flex flex-wrap gap-2">
                @for(size of product.ProductSizeInventory; track $index) {
                <div class="size-stock-box d-flex flex-column rounded overflow-hidden shadow-sm" [title]="size.InventorySize?.Remarks || 'Stock: ' + size.CurrentStock">
                  <div class="size-header fw-bold text-center px-2 py-1">{{ size.InventorySize?.Size }}</div>
                  <div class="stock-body text-center px-2 py-1" [class.text-danger]="size.CurrentStock === 0">{{ size.CurrentStock }}</div>
                </div>
                }
              </div>
            </div>

            <!-- Price Section -->
            <div class="mt-3 pt-3 border-top border-secondary-subtle">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <h3 class="fw-bold text-white mb-0">₹{{ product.Amount * (1 - product.StudentDiscount / 100) | number : "1.2-2" }}</h3>
                </div>
                <div class="text-end">
                  <div class="small font-gray opacity-75" style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px">Stock</div>
                  <div class="fw-bold font-green">{{ product.CurrentStock }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- <div class="mt-4">
    <mat-paginator [pageSizeOptions]="[8, 12, 24]" [length]="length" showFirstLastButtons></mat-paginator>
  </div> -->
</div>
